


























































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { mapState } from 'vuex';
import _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import showFilesModal from '../components/showFiles.vue';
import { Spinner } from 'vue-image-spinner2';
import { asyncForEach } from '@/utils';
import Pica from 'pica';

@Component({
    name: 'product-categories-modal',
    components: {
        showFilesModal,
        Spinner,
    },
    computed: {
        ...mapState('productCategories', ['activeProductCategoryLoading', 'activeProductCategory']),
        ...mapState('productCategories', ['allProductCategories']),
        ...mapState('productCategories', {
            allProductCategories: (state: any) => {
                let null_category = _.find(state.allProductCategories, function (o) {
                    return o.id == 0;
                });
                if (!null_category) {
                    state.allProductCategories.push({
                        id: 0,
                        name: 'Sin categoría',
                        slug: 'sin-categoria',
                    });
                }

                return _.orderBy(state.allProductCategories, 'name', 'desc');
            },
        }),
        ...mapState('auth', ['currentUser']),
    },
})
export default class ProductCategoriesModal extends Vue {
    //
    private activeProductCategory!: any;
    private activeProductCategoryLoading!: any;
    public allProductCategories!: any;

    private searchQuery: string = '';
    private options: string = '';

    public categorySelected: any = '';

    public file_type: any = '';

    private currentUser!: any;

    canSee(roles: any) {
        return _.intersection(roles, [this.currentUser.role.name]).length > 0;
    }

    get disableButton() {
        //method added to validate the parent Category
        // this.allProductCategories.push({
        // id: 0,
        // name: 'Sin categoría',
        // slug: 'sin-categoria',
        // });
        if (this.activeProductCategory.parent_id) {
            let parentCategory = _.find(this.allProductCategories, { id: this.activeProductCategory.parent_id });
            this.categorySelected = parentCategory;
        } else {
            // this.categorySelected = {
            //     slug: 'sin-categoria',
            //     name: 'Sin categoría',
            //     id: 192,
            // };
        }
        return false;
    }

    onSaveProductCategory() {
        this.activeProductCategory.slug = this.string_to_slug(this.activeProductCategory.name);
        this.$store.dispatch('productCategories/postOne', {
            vm: this,
            data: this.activeProductCategory,
            parent_id: this.categorySelected.id == 0 ? null : this.categorySelected.id,
        });
    }

    onDeleteProductCategory() {
        this.$store.dispatch('productCategories/deleteOne', { id: this.activeProductCategory.id, vm: this });
        setTimeout(() => {
            this.$store.dispatch('productCategories/getAll');
            this.$bvModal.hide('product-categories-modal');
        });
    }

    string_to_slug(str: string) {
        str = str.replace(/^\s+|\s+$/g, ''); // trim
        str = str.toLowerCase();

        // remove accents, swap ñ for n, etc
        var from = 'àáãäâèéëêìíïîòóöôùúüûñç·/_,:;';
        var to = 'aaaaaeeeeiiiioooouuuunc------';

        for (var i = 0, l = from.length; i < l; i++) {
            str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
        }

        str = str
            .replace(/[^a-z0-9 -]/g, '') // remove invalid chars
            .replace(/\s+/g, '-') // collapse whitespace and replace by -
            .replace(/-+/g, '-'); // collapse dashes

        return str;
    }

    async onFileChange(e: any) {
        switch (this.file_type) {
            case 'cover':
                if (e.target) {
                    const files = e.target.files;
                    await asyncForEach(files, async (file: any) => {
                        if (!file) return;
                        try {
                            this.activeProductCategory.cover = this.formatFile(file, '', '');
                            console.log({ data: this.activeProductCategory.cover });

                            let dinamic_width = 1200;
                            let dinamic_height = 400;
                            // convert original file to webp
                            const resizedFile: any = await this.resizeImage(file, 0, 0, 'cover');
                            this.activeProductCategory.complete_cover.push(this.formatFile(resizedFile, 0, 0));
                            const resizedFiles: any = await this.resizeImage(file, dinamic_width, dinamic_height, 'cover');
                            this.activeProductCategory.complete_cover.push(this.formatFile(resizedFiles, dinamic_width, dinamic_height));
                        } catch (error) {
                            console.error('Error resizing image cover:', error);
                        }
                        // files.forEach((file: any) => {
                        //     let formData = new FormData();
                        //     formData.append('image', file, file.name);
                        //     this.activeProductCategory.cover = {
                        //         id: uuidv4(),
                        //         sort: null,
                        //         url: URL.createObjectURL(file),
                        //         origin: 'upload',
                        //         file: formData,
                        //         name: file.name,
                        //     };
                    });
                } else {
                    this.activeProductCategory.cover = {
                        id: e.id,
                        sort: null,
                        url: `https://directus.prodelec.app/assets/${e.id}`,
                        origin: 'directus-update',
                        file: null,
                    };
                }
                break;
            case 'featured':
                if (e.target) {
                    const files = e.target.files;
                    // files.forEach((file: any) => {
                    //     let formData = new FormData();
                    //     formData.append('image', file, file.name);
                    //     this.activeProductCategory.image = {
                    //         id: uuidv4(),
                    //         sort: null,
                    //         url: URL.createObjectURL(file),
                    //         origin: 'upload',
                    //         file: formData,
                    //         name: file.name,
                    //     };
                    await asyncForEach(files, async (file: any) => {
                        if (!file) return;
                        try {
                            this.activeProductCategory.image = this.formatFile(file, '', '');
                            let dinamic_width = 150;
                            let dinamic_height = 150;
                            // convert original file to webp
                            const resizedFile: any = await this.resizeImage(file, 0, 0, 'featured');
                            this.activeProductCategory.complete_image.push(this.formatFile(resizedFile, 0, 0));
                            do {
                                const resizedFile: any = await this.resizeImage(file, dinamic_width, dinamic_height, 'featured');
                                this.activeProductCategory.complete_image.push(this.formatFile(resizedFile, dinamic_width, dinamic_height));
                                dinamic_width += 650;
                                dinamic_height += 650;
                            } while (dinamic_width <= 800);
                        } catch (error) {
                            console.error('Error resizing image:', error);
                        }
                    });
                } else {
                    this.activeProductCategory.image = {
                        id: e.id,
                        sort: null,
                        url: `https://directus.prodelec.app/assets/${e.id}`,
                        origin: 'directus-update',
                        file: null,
                    };
                }
                break;

            default:
                console.log('Img progress...');
                break;
        }
    }

    resizeImage(file: any, width: any, height: any, type: string) {
        return new Promise((resolve, reject) => {
            const pica = new Pica();
            const img = new Image();
            img.onload = async () => {
                try {
                    if (type == 'cover') {
                        if (img.width >= 1800 && img.height >= 600) {
                            const resizedCanvas = document.createElement('canvas');
                            width == 0 ? (resizedCanvas.width = img.width) : (resizedCanvas.width = width);
                            height == 0 ? (resizedCanvas.height = img.height) : (resizedCanvas.height = height);
                            const resizeOptions = {
                                filter: 'mks2013',
                            };
                            await pica.resize(img, resizedCanvas, resizeOptions);
                            resizedCanvas.toBlob((blob) => {
                                const resizedFile = new File([blob], file.name, { type: 'image/webp' });
                                resolve(resizedFile);
                            }, 'image/webp');
                        } else {
                            this.activeProductCategory.cover = '';
                            this.$bvToast.toast('Lo sentimos, la imagen no cumple con las dimensiones mínimas (1500x1500)', {
                                title: `Imagen no válida`,
                                variant: 'warning',
                                toaster: 'b-toaster-top-center',
                                autoHideDelay: 5000,
                            });
                            return false;
                        }
                    } else if (type == 'featured') {
                        if (img.width >= 1500 && img.height >= 1500) {
                            const resizedCanvas = document.createElement('canvas');
                            width == 0 ? (resizedCanvas.width = img.width) : (resizedCanvas.width = width);
                            height == 0 ? (resizedCanvas.height = img.height) : (resizedCanvas.height = height);
                            const resizeOptions = {
                                filter: 'mks2013',
                            };
                            await pica.resize(img, resizedCanvas, resizeOptions);
                            resizedCanvas.toBlob((blob) => {
                                const resizedFile = new File([blob], file.name, { type: 'image/webp' });
                                resolve(resizedFile);
                            }, 'image/webp');
                        } else {
                            this.activeProductCategory.image = '';
                            this.$bvToast.toast('Lo sentimos, la imagen no cumple con las dimensiones mínimas (1500x1500)', {
                                title: `Imagen no válida`,
                                variant: 'warning',
                                toaster: 'b-toaster-top-center',
                                autoHideDelay: 5000,
                            });
                            return false;
                        }
                    }
                } catch (error) {
                    reject(error);
                }
            };
            img.src = URL.createObjectURL(file);
        });
    }

    formatFile(resizedFile: any, width: any, height: any) {
        let file_name = resizedFile.name.split('.')[0];
        file_name = file_name + '_' + width + 'x' + height;
        let formData = new FormData();
        formData.append('title', file_name);
        formData.append('image', resizedFile, resizedFile.name);
        return {
            id: uuidv4(),
            sort: null,
            url: URL.createObjectURL(resizedFile),
            origin: width && width > 0 ? 'resize' : 'upload',
            file: formData,
            name: file_name,
        };
    }

    // onImageCoverChange(e) {
    //     const files = e.target.files;
    //     files.forEach((file) => {
    //         let formData = new FormData();
    //         formData.append('image', file, file.name);
    //         this.activeProductCategory.cover = {
    //             id: uuidv4(),
    //             sort: null,
    //             url: URL.createObjectURL(file),
    //             origin: 'upload',
    //             file: formData,
    //         };
    //     });
    // }

    onRemoveImg() {
        this.activeProductCategory.complete_image = '[]';
        this.activeProductCategory.image = '';
    }

    onRemoveCoverImg() {
        this.activeProductCategory.complete_cover = '[]';
        this.activeProductCategory.cover = '';
    }

    onOpenFilesModal(file_type: string) {
        this.file_type = file_type;
        setTimeout(() => {
            this.$bvModal.show('show-files-modal');
        }, 400);
    }

    setFileType(file_type: string) {
        this.file_type = file_type;
    }
}
